import { defineStore } from "pinia";
import { createClient } from "@/sdk";
import type { WebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto } from "~/sdk/generated/models";
import { DefaultApiError } from "@microsoft/kiota-abstractions";

export const useTldCatalogStore = defineStore("tld-catalog", () => {
  const cartStore = useCartStore();
  const config = useRuntimeConfig();

  const client = createClient(config.public.apiServer);

  const isReady = ref(false);
  const catalog =
    ref<
      WebhusetOrderApiFeaturesCatalogTldGetResponse_CatalogTldItemResultRestDto[]
    >();

  watch(
    () => cartStore.coupon,
    () => {
      isReady.value = false;
      console.log("Coupon changed", cartStore.coupon);
    }
  );

  const fetchCatalog = async () => {
    try {
      const tld = await client.catalog.tld.get({
        queryParameters: {
          coupon: cartStore.coupon,
        },
      });

      catalog.value = tld?.products;
      isReady.value = true;
    } catch (err) {
      if (err instanceof DefaultApiError && err.responseStatusCode === 404) {
        await nextTick(() => {
          showError("Ugyldig kupongkode");
        });
      } else {
        console.error("Error loading TLD catalog", err);
        await nextTick(() => {
          showError("En uventet feil oppstod under henting av produkter");
        });
      }
    }
  };

  watch(
    isReady,
    async () => {
      if (!isReady.value) {
        await fetchCatalog();
      }
    },
    {
      immediate: true,
    }
  );

  return {
    isReady,
    catalog,
    getByTld: (tld: string) => {
      return catalog.value?.find((t) => t.tld === tld);
    },
  };
});
